import { createContext, useEffect, useState, useContext } from "react"

export const defaultGlobalProviderValues = {
  onSearchCount: 0,
  registerOnSearch: () => {}
}

const GlobalContext = createContext(defaultGlobalProviderValues)

const GlobalProvider = ({ children }) => {
  const [onSearchCount, setOnSearchCount] = useState(
    defaultGlobalProviderValues.onSearchCount
  )

  const registerOnSearch = () => {
   setOnSearchCount(state => state + 1)
  }

  const values = {
    onSearchCount,
    registerOnSearch
  }

  return (
    <GlobalContext.Provider value={values}>{children}</GlobalContext.Provider>
  )
}
const useGlobal = () => useContext(GlobalContext)

export { GlobalContext, GlobalProvider, useGlobal }
